import { defineStore } from "pinia"
import apiMine from "@/api/api/apiMine.js"
import { firebaseUtils, getSA } from "@/utils/analytic/firebaseUtils.js"
import globalConfig from "@/config/config.js"
import { isDev } from "@/utils/tools.js"

const AB_TEST_COMMON_CONFIG = {
  DEFAULT_VALUE: "__empty__",
  VALUE_TYPE: "String",
  TIMEOUT: 3000,
}

const AB_TEST_NAME = {
  discount_type: {
    test: "discount_different_type_20250427",
    prod: "discount_different_type_20250427",
  },
  discount_show: {
    test: "discount_coupon_show_20250427",
    prod: "discount_coupon_show_20250427",
  },
  couponShow: {
    test: "coupon_show_20250509",
    prod: "coupon_show_20250509",
  },
  optimizeSubscripbeGuideStrips: {
    test: "optimize_subscripbe_guide_strips_20250509",
    prod: "optimize_subscripbe_guide_strips_20250509",
  },
  createSubscribeType: {
    test: "create_subscribe_type_20250509",
    prod: "create_subscribe_type_20250509",
  },
  createSubscribeGuideBarType: {
    test: "different_guide_bar_show_20250522",
    prod: "different_guide_bar_show_20250530",
  }
}

const abtestStore = defineStore({
  id: "abtestStore",
  state: () => {
    return {
      paymentABResult: "",
      subscriptionPriceType: "", // 订阅年度会员价格类型
      subscriptionTabType: "",
      discount_type: "",
      // 无(对照组) discount_type_null
      // 年(实验组1) discount_type_yearly_all
      // pro(实验组2) discount_type_pro_all
      // 通用(实验组3) discount_type_all
      discount_show: "",
      // 只展示一次(对照组) discount_show_once
      // 展示五天，五天内过期了无限展示(实验组) discount_show_5days
      couponShow: "",
      // 展示 coupon_show  不展示coupon_not_show

      createSubscribeGuideBarType: "",
      // vocal_voice shape_melody download_stem generate_similar_song
    }
  },
  actions: {
    // 上拉加载，
    setABData(data) {
      this.paymentABResult = data
    },
    async initPayment() {
      // 使用 Promise 包装 fastFetchABTest 的异步逻辑
      return new Promise(async (resolve, reject) => {
        if (!firebaseUtils.abtest?.fastFetchABTest) {
          await getSA?.()
        }
        firebaseUtils.abtest?.fastFetchABTest({
          param_name: isDev() ? "different_cashier_display_20250314" : "different_cashier_display_20250314",
          default_value: "__empty__",
          value_type: "String",
          timeout_milliseconds: 3000,
          custom_properties: {
            platform: globalConfig.platform,
          },
          callback: (result) => {
            console.log("ABresult🔥🔥=>", result)
            this.setABData(result) // 调用 setABData 方法处理结果
            this.paymentABResult = result // 将结果存储到 paymentABResult 中
            resolve(result) // 将结果传递给 Promise
          },
          error_callback: (error) => {
            console.error("Error fetching AB test result:", error)
            reject(error) // 如果发生错误，reject Promise
          },
        })
      })
    },
    async getPaymentABResult() {
      if (this.paymentABResult === "") {
        await this.initPayment()
      }
      return this.paymentABResult // 返回存储的结果
    },
    async clearPaymentABResult() {
      this.paymentABResult = ""
    },
    async initSubscriptionPrice(callbackFun) {
      if (!firebaseUtils.abtest?.fastFetchABTest) {
        await getSA?.()
      }
      firebaseUtils.abtest?.fastFetchABTest({
        param_name: isDev() ? "yearlysub_price_test_20250212" : "yearlysub_price_test_20250217",
        default_value: "__empty__",
        value_type: "String",
        timeout_milliseconds: 3000,
        custom_properties: {
          platform: globalConfig.platform,
        },
        callback: (result) => {
          console.log("subABresult🔥🔥=>", result)
          this.subscriptionPriceType = result
          callbackFun && callbackFun()
        },
      })
    },
    // 订阅页面tab展示实验
    async initSubscriptionTab(callbackFun) {
      if (!firebaseUtils.abtest?.fastFetchABTest) {
        await getSA?.()
      }
      firebaseUtils.abtest?.fastFetchABTest({
        param_name: isDev() ? "default_display_monthly_plan_20250219" : "default_display_monthly_plan_20250220",
        default_value: "__empty__",
        value_type: "String",
        timeout_milliseconds: 3000,
        custom_properties: {
          platform: globalConfig.platform,
        },
        callback: (result) => {
          console.log("subTabABresult🔥🔥=>", result)
          this.subscriptionTabType = result
          callbackFun && callbackFun()
        },
      })
    },
    async fetchABTestResult(stateProperty) {
      return new Promise(async (resolve, reject) => {
        if (!firebaseUtils.abtest?.fastFetchABTest) {
          await getSA?.()
        }
        firebaseUtils.abtest?.fastFetchABTest({
          param_name: AB_TEST_NAME[stateProperty][isDev() ? "test" : "prod"],
          default_value: AB_TEST_COMMON_CONFIG.DEFAULT_VALUE,
          value_type: AB_TEST_COMMON_CONFIG.VALUE_TYPE,
          timeout_milliseconds: AB_TEST_COMMON_CONFIG.TIMEOUT,
          custom_properties: {
            platform: globalConfig.platform,
          },
          callback: (result) => {
            console.log("AB result🔥🔥 =>", stateProperty, result)
            this[stateProperty] = result
            resolve(result)
          },
          error_callback: (error) => {
            console.error("Error fetching AB test result:", error)
            reject(error)
          },
        })
      })
    },

    async initDiscountType() {
      if (this.discount_type === "" || this.discount_type == "__empty__") {
        return this.fetchABTestResult("discount_type")
      }
      console.log("discount_type🔥🔥=>", this.discount_type)
      return this.discount_type
    },

    async initDiscountShow() {
      if (this.discount_show === "" || this.discount_show == "__empty__") {
        return this.fetchABTestResult("discount_show")
      }
      console.log("discount_show=>", this.discount_show)
      return this.discount_show
    },

    async initCouponShow() {
      if (this.couponShow === "" || this.couponShow == "__empty__") {
        return this.fetchABTestResult("couponShow")
      }
      console.log("couponShow_show=>", this.couponShow)
      return this.couponShow
    },

    async initCreateSubscribeType() {
      if (!this.createSubscribeGuideBarType || this.createSubscribeGuideBarType == "__empty__") {
        return this.fetchABTestResult("createSubscribeGuideBarType");
      }
      console.log("createSubscribeGuideBarType🔥🔥=>", this.createSubscribeGuideBarType);
      return this.createSubscribeGuideBarType; 
    },
  },
})

export default abtestStore
